import React, { createContext, useContext } from 'react';
import type { FC, ReactNode } from 'react';
import { readWixConfig } from './files/wix.config.js';

export interface ProjectModel {
  projectFolder: string;
  metaSiteId: string;
  veloAppId: string;
}

export async function loadProjectModel(
  projectFolder: string
): Promise<ProjectModel> {
  const config = await readWixConfig(projectFolder);
  return {
    projectFolder,
    metaSiteId: config.siteId,
    veloAppId: config.veloAppId,
  };
}

const ProjectModelContext = createContext<ProjectModel | null>(null);

interface Props {
  model: ProjectModel;
  children: ReactNode;
}

export const ProjectModelProvider: FC<Props> = ({ model, children }) => {
  return (
    <ProjectModelContext.Provider value={model}>
      {children}
    </ProjectModelContext.Provider>
  );
};

export function useProjectModel(): ProjectModel {
  const context = useContext(ProjectModelContext);
  if (context == null) {
    throw new Error(
      'useProjectModel() cannot be used without an <ProjectModelProvider>'
    );
  }
  return context;
}
